<div class="current-bets-container">
  <div class="content {{ 'grid-cols-' + _betService.playerBets.length }}">
    @for (bet of _betService.playerBets; track bet.betTypeId; let i = $index) {
      <div class="items">
        <div
          class="header"
          [class.rounded-tl-xl]="i === 0"
          [class.rounded-tr-xl]="i === _betService.playerBets.length - 1"
        >
          {{ getBetTotal(bet.betTypeId) }}
          COINS
        </div>
        <div class="bets">
          <div>Current Bet:</div>
          <div>{{ bet.total }}</div>
        </div>

        <div class="payouts">
          <div>Payout:</div>
          <div>{{ bet.payout }}</div>
        </div>
      </div>
    }
  </div>
</div>
